export default __webpack_public_path__ + "static/media/Tristanpinguin.2b9dfa00.jpg";